import { ScheduledRecovery, isScheduledRecoveryLogged } from "../../types/scheduledRecovery";

interface RecoveryScheduleCardProps {
  item: ScheduledRecovery;
  onClick?: () => void;
}

/** Coach-assigned recovery on the athlete schedule. */
const RecoveryScheduleCard: React.FC<RecoveryScheduleCardProps> = ({
  item,
  onClick,
}) => {
  const logged = isScheduledRecoveryLogged(item);
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={!onClick || logged}
      className={`flex w-full items-center gap-2 rounded-xl border px-3 py-2.5 text-left transition-colors ${
        logged
          ? "border-base-300 bg-base-200/50"
          : "border-sky-500/30 bg-sky-500/10 hover:bg-sky-500/15"
      } ${onClick && !logged ? "cursor-pointer" : "cursor-default"}`}
    >
      <span className="min-w-0 flex-1">
        <span className="block truncate text-sm font-medium text-base-content font-grotesk">
          {item.modality}
        </span>
        {item.notes.trim() && (
          <span className="block truncate text-xs text-base-content/55 font-grotesk">
            {item.notes.trim()}
          </span>
        )}
      </span>
      <span
        className={`inline-flex shrink-0 items-center rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide font-grotesk ${
          logged ? "bg-success/15 text-success" : "bg-sky-500/15 text-sky-700"
        }`}
      >
        {logged ? "Logged" : "To log"}
      </span>
    </button>
  );
};

export default RecoveryScheduleCard;
